module.exports = __webpack_public_path__ + "img/head.044d84e3.svg";